<template>
  <footer class="footer" id="footer" :style="{ position: position }">
    <div class="wrapper clear-float">
      <div class="icon-box">
        <img @click="displayPopUpBox(!showQRCode)" v-lazy="'/static/images/wechat_icon@2X.png'" alt="WeChat" title="WeChat" class="icon" />
        <a href="https://www.linkedin.com/company/dizal-pharma/life" target="_blank">
          <img v-lazy="'/static/images/in_icon@2X.png'" alt="LinkedIn" title="LinkedIn" class="icon" />
        </a>
      </div>
      <div class="copyright-content clear-float">
        <ul class="terms-legal right">
          <router-link :to="{ name: 'contactLink' }" tag="li">{{ $t('contact_us') }}</router-link>
          <span>|</span>
          <router-link :to="{ name: 'aboutDeclarationLink', query: { key: 'terms_of_use' } }" tag="li">{{ $t('terms_of_use.name') }}</router-link>
          <span>|</span>
          <router-link :to="{ name: 'aboutDeclarationLink', query: { key: 'privacy_policy' } }" tag="li">{{ $t('privacy_policy.name') }}</router-link>
        </ul>
        <div class="copyright-left left">
          <span class="pc-copy">
            <!--{{$t('copyright')}}-->
            © 2024 迪哲医药股份有限公司版权所有
          </span>
          <a href="https://beian.miit.gov.cn/" target="_blank" class="site-ref">苏ICP备17074666号-1</a>
          <span class="mobile-copy">{{ $t('copyright') }}</span>
        </div>
      </div>
    </div>
    <pop-up-box class="show-img" v-model="showQRCode" :showClose="true">
      <div class="content" slot="content">
        <img v-lazy="'/static/images/wechat.png'" alt="" class="img" />
      </div>
    </pop-up-box>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    position: {
      type: String,
      default: 'absolute'
    }
  },
  components: {
    PopUpBox: () => import('@/components/PopUpBox.vue')
  },
  computed: {
    // 控制展示“二维码”
    showQRCode: {
      get() {
        return this.$store.getters.isShowQRCode
      },
      set(show) {
        this.$store.dispatch('setShowQRCode', show)
      }
    },
    lang: {
      get() {
        return this.$store.getters.getLang
      },
      set(lang) {
        this.$store.dispatch('setLang', lang)
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    // 控制展示“二维码”弹出框
    displayPopUpBox(show = false) {
      this.showQRCode = show
    }
  }
}
</script>

<style lang="less">
#footer {
  font-size: 14px;
  width: 100%;
  color: rgba(255, 255, 255, 0.5);
  background-color: rgba(53, 62, 72, 1);
  position: absolute;
  bottom: 0;
  left: 0;
  // 备案编号
  .site-ref {
    text-indent: 1em;
  }
  .site-ref,
  .email {
    line-height: 16px;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.5);
    &:hover {
      color: #fff;
    }
  }
  .icon {
    .icon-img {
      cursor: pointer;
      vertical-align: bottom;
      height: 20px;
      &.in {
        margin-left: 5px;
      }
    }
  }
  // wechat in
  .icon-box {
    img {
      width: 40px;
      height: 40px;
      padding: 5px 0;
      display: inline-block;
      cursor: pointer;
      transition: padding ease-in-out 0.75s;
      -moz-transition: padding ease-in-out 0.75s;
      -webkit-transition: padding ease-in-out 0.75s;
      -o-transition: padding ease-in-out 0.75s;
      &:hover {
        padding-top: 0;
        padding-bottom: 10px;
        // background-color: rgba(243, 14, 65, 1);
      }
      &:first-child {
        margin-right: 10px;
      }
    }
  }
  .wrapper {
    padding: 25px 0;
    flex-direction: column;
    .copyright-content {
      margin-top: 25px;
      color: #fff;
      .left,
      .right {
        height: 30px;
        line-height: 30px;
      }
      .left {
        font-size: 12px;
        a {
          color: #fff;
          display: inline-block;
          margin-right: 20px;
          &:hover {
            color: rgba(202, 17, 58, 1);
          }
        }
        .mobile-copy {
          display: none;
        }
      }
      .right {
        height: 30px;
        span {
          margin: 0 20px;
        }
        li {
          display: inline-block;
          cursor: pointer;
          &:hover {
            color: rgba(202, 17, 58, 1);
            font-weight: blod;
          }
        }
      }
    }
  }
}
.com-logo {
  height: 50px;
}
.show-img {
  .content {
    .img {
      max-width: 260px;
    }
  }
}

@media only screen and (max-width: 600px) {
  #footer {
    bottom: auto;
  }
}

@media screen and (max-width: 750px) {
  #footer {
    .icon-box img {
      &:hover {
        padding: 5px 0;
      }
      &:first-child {
        margin-right: 10px;
      }
    }
    .wrapper {
      .copyright-content {
        margin-top: 5px;
        // display: flex;
        // flex-direction: column-reverse;
        .site-ref {
          text-indent: 0;
          margin-top: 20px;
        }
        .pc-copy {
          display: none;
        }
        .mobile-copy {
          display: block !important;
        }
        .left,
        .right {
          height: auto;
          display: block;
          float: none;
        }
        .right {
          font-size: 14px;
          span {
            margin: 0 10px;
          }
        }
      }
    }
  }
  .com-logo {
    height: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue